



















import React, { useEffect, useState } from "react";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import PublicHeader from "./General/Header";
import PublicHome from "./public/Home";
import About from "./public/About";
import Pricing from "./public/Pricing";
import Contact from "./public/Contact";
import Privacypolicy from "./public/Privacypolicy";
import PublicFooter from "./General/Footer";
import Scollertop from "./public/Scollertop";

import logo from "./assets/dectwin-billing-logo.jpeg";
import Home from "./components/Pages/Home";
import { MdMenuOpen } from "react-icons/md";
import Loading_screen from "./General/Loading_screen";
import Sidebar from "./General/Sidebar";
import Overview from "./components/Pages/Overview";
import Login from "./components/Pages/Login";

import Party from "./components/Party/Party";
import Items from "./components/Items/Items";
import ManageBussines from "./components/ManageBussiness/ManageBussines";
import Bank_account from "./components/Bank Account/Bank_account";
import Pnf from "./General/pnf";
import Cash from "./components/Cashin hand/Cash";
import Addstaff from "./components/Add staff/Addstaff";
import Purchase from "./components/Add purchase/Purchase";
import Expenses from "./components/Add Expenses/Expenses";
import GenerateBarcode from "./components/Generate Barcode/GenerateBarcode";
import Addpurchase from "./components/Add purchase/Addpurchase";
import PurchaseReturn from "./components/Add purchase/PurchaseReturn";
import Expenseshistory from "./components/Add Expenses/Expenseshistory";
import LoyalityPoints from "./components/Loyality points/Loyalitypoints";
import Setting from "./components/Setting/Setting";
import Notification from "./components/Notification/Notification";
import ThemeToggle from "./General/ThemeToggle";
import Premium from "./components/GetPremium/Premium";
import Reports from "./components/Reports/Reports";
import Saleswisereport from "./components/Reports/Saleswisereport";
import SettlementReport from "./components/Reports/SettlementReport";
import TaxReport from "./components/Reports/TaxReport";
import Stoke from "./components/Reports/Stoke";
import ProfitLossReport from "./components/Reports/ProfitLossReport";
import Cheque from "./components/Cheque/Cheque";
import PurReturnHistory from "./components/Add purchase/PurReturnHistory";
import AddEstimate from "./components/Estimate/AddEstimate";
import EsitmateHistory from "./components/Estimate/EsitmateHistory";
import ConvertToSsle from "./components/Estimate/ConvertToSsle";
import AddSale from "./components/Sale/AddSale";
import SaleHistory from "./components/Sale/SaleHistory";
import SaleReturn from "./components/Sale/SaleReturn";
import SaleReturnHistory from "./components/Sale/SaleReturnHistory";
import PaymentInHistory from "./components/Sale/PaymentInHistory";
import Challan_Invoice from "./components/Challan/Challan_Invoice";
import Challan_List from "./components/Challan/Challan_List";
import Services from "./components/Items/Services";
import Units from "./components/Items/Units";
import Category from "./components/Items/Category";
import Branch from "./components/ManageBussiness/Branch";
import { RiNotification3Fill } from "react-icons/ri";
import InvoicePreview from "./components/Sale/InvoicePreview";
import { Link } from "react-router-dom";
import { LiaUserEditSolid } from "react-icons/lia";

import "./App.css";
import MobileBottomNav from "./General/MobileBottomNav";


function App() {
  // const [loading, setLoading] = useState(true);
  const [lowStockCount, setLowStockCount] = useState(0);
  const [showSidebar, setShowSidebar] = useState(false);

  const [isLogin, setIsLogin] = useState(
    !!localStorage.getItem("user_data")
  );
  const [appTheme, setAppTheme] = useState(() => {
  try {
    const settings =
      JSON.parse(localStorage.getItem("settings")) || {};

    return settings.theme_color === "Dark"
      ? "Dark"
      : "Light";
  } catch (error) {
    return "Light";
  }
});
useEffect(() => {
  const handleThemeChange = (event) => {
    setAppTheme(
      event.detail === "Dark"
        ? "Dark"
        : "Light"
    );
  };

  window.addEventListener(
    "appThemeChanged",
    handleThemeChange
  );

  return () => {
    window.removeEventListener(
      "appThemeChanged",
      handleThemeChange
    );
  };
}, []);              
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 768
  );

  const [clientData, setClientData] = useState(() =>
    JSON.parse(localStorage.getItem("user_data"))
  );

  const role = localStorage.getItem("role");



  const fetchLowStockCount = async () => {
    try {
      const userData = JSON.parse(
        localStorage.getItem("user_data")
      );

      const clientId = userData?.id;

      if (!clientId) {
        setLowStockCount(0);
        return;
      }

      const response = await axios.get(
        `https://api.dectwinbilling.com/fetch-inventory/${clientId}`
      );

      const inventory = Array.isArray(response.data)
        ? response.data
        : [];

      const lowStockItems = inventory.filter((item) => {
        const stock = Number(item.stock || 0);
        const minimumStock = Number(item.min_to_maintain || 0);

        return stock <= minimumStock;
      });

      setLowStockCount(lowStockItems.length);

    } catch (error) {
      console.error("Low Stock Count Error:", error);
      setLowStockCount(0);
    }
  };


  useEffect(() => {
    if (isLogin) {
      fetchLowStockCount();
    }
  }, [isLogin]);




  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () =>
      window.removeEventListener(
        "resize",
        handleResize
      );
  }, []);



  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setLoading(false);
  //   }, 3000);

  //   return () => clearTimeout(timer);
  // }, []);

//   useEffect(() => {
//   document.documentElement.setAttribute(
//     "data-bs-theme",
//     appTheme === "Dark" ? "dark" : "light"
//   );

//   document.body.setAttribute(
//     "data-bs-theme",
//     appTheme === "Dark" ? "dark" : "light"
//   );
// }, [appTheme]);



useEffect(() => {
  document.body.style.backgroundColor =
    appTheme === "Dark" ? "#121212" : "";

  document.body.style.color =
    appTheme === "Dark" ? "" : "";

  return () => {
    document.body.style.backgroundColor = "";
    document.body.style.color = "";
  };
}, [appTheme]);

  // if (loading) {
  //   return <Loading_screen />;
  // }


  return (
    <BrowserRouter>


      {!isLogin ? (

        <>
          <Scollertop />

          <PublicHeader />

          <main className="main-content">

            <Routes>

              {/* PUBLIC HOME */}
              <Route
                path="/"
                element={<PublicHome />}
              />

              {/* ABOUT */}
              <Route
                path="/about"
                element={<About />}
              />

              {/* CONTACT */}
              <Route
                path="/contact"
                element={<Contact />}
              />

              {/* PRICING */}
              <Route
                path="/pricing"
                element={<Pricing />}
              />

              {/* PRIVACY POLICY */}
              <Route
                path="/privacypolicy"
                element={<Privacypolicy />}
              />

              {/* BILLING LOGIN */}
              <Route
                path="/login"
                element={
                  <Login
                    setIsLogin={setIsLogin}
                    setClientData={setClientData}
                  />
                }
              />

            </Routes>

          </main>

          <PublicFooter />
        </>

      ) : (

        /* =====================================================
           BILLING SOFTWARE
           USER IS LOGGED IN
        ===================================================== */

        <>
<div
  // className={`app-theme ${
  //   appTheme === "Dark"
  //     ? "theme-dark"
  //     : "theme-light"
  // }`}
     style={{
      backgroundColor:
        appTheme === "Dark"
          ? "#121212"
          : "transparent",

      minHeight: "100vh",

      transition:
        "background-color 0.3s ease",
    }}
>
          {/* =================================================
              SIDEBAR
          ================================================= */}

          {showSidebar && (
            // <Sidebar
            //   setShowSidebar={setShowSidebar}
            //   setIsLogin={setIsLogin}
            //   role={role}
            //   clientData={clientData}
            // />
            <Sidebar
  setShowSidebar={setShowSidebar}
  setIsLogin={setIsLogin}
  role={role}
  clientData={clientData}
/>
          )}


          <div
            style={{
              marginLeft:
                showSidebar && !isMobile
                  ? "198px"
                  : "0",

              width:
                showSidebar && !isMobile
                  ? "calc(100% - 230px)"
                  : "100%",

              transition: "all 0.3s ease",
            }}
          >

            {/* =================================================
                BILLING HEADER
            ================================================= */}

            {!showSidebar && (

              <div
                className="header-area"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 20px",
                  width: "100%",
                }}
              >

                {/* LEFT SIDE */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: isMobile ? "8px" : "15px",
                    flex: 1,
                    minWidth: 0,
                  }}
                >

                  {/* MENU BUTTON */}
                  <button
                    onClick={() => setShowSidebar(true)}
                    className="menu-btn"
                  >
                    <MdMenuOpen />
                  </button>


                  {/* USER IMAGE */}
                  <img
                    src={
                      clientData?.image
                        ? `https://api.dectwinbilling.com/dUploads/${clientData.image}?t=${clientData.imageUpdatedAt || ""}`
                        : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                    }
                    alt="User"
                    className="rounded-circle border"
                    width="55"
                    height="55"
                    style={{
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://cdn-icons-png.flaticon.com/512/3135/3135715.png";
                    }}
                  />


                  {/* BUSINESS NAME */}
                  <h5
                    style={{
                      margin: 0,
                      fontWeight: "900",
                      fontSize: isMobile ? "16px" : "20px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: isMobile ? "70px" : "200px",
                    }}
                  >
                    {clientData?.business_name}
                  </h5>


                  {/* EDIT BUSINESS */}
                  <Link to="/managebussines">

                    <button
                      className="btn btn-sm text-white rounded-circle shadow"
                      style={{
                        background: "var(--primary-color)",
                        width: isMobile ? "34px" : "40px",
                        height: isMobile ? "34px" : "40px",
                        padding: 0,
                        flexShrink: 0,
                      }}
                    >
                      <LiaUserEditSolid
                        size={isMobile ? 18 : 24}
                      />
                    </button>

                  </Link>


                  {/* RIGHT SIDE HEADER */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: isMobile ? "8px" : "15px",
                      marginLeft: "auto",
                      flexShrink: 0,
                    }}
                  >

                    {/* NOTIFICATION */}
                    <Link
                      to="/notificaton"
                      style={{
                        textDecoration: "none",
                        position: "relative",
                        display: "inline-block",
                      }}
                    >

                      <div
                        style={{
                          width: isMobile ? "36px" : "42px",
                          height: isMobile ? "36px" : "42px",
                          borderRadius: "50%",
                          background: "#dc3545",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          position: "relative",
                        }}
                      >

                        <RiNotification3Fill
                          size={isMobile ? 18 : 22}
                          color="#fff"
                        />


                        {/* LOW STOCK COUNT */}
                        {lowStockCount > 0 && (

                          <span
                            style={{
                              position: "absolute",
                              top: "-7px",
                              right: "-7px",
                              minWidth: "20px",
                              height: "20px",
                              padding: "0 5px",
                              borderRadius: "50%",
                              background: "#000",
                              color: "#fff",
                              fontSize: "11px",
                              fontWeight: "700",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "2px solid #fff",
                              lineHeight: "1",
                            }}
                          >
                            {lowStockCount > 99
                              ? "99+"
                              : lowStockCount}
                          </span>

                        )}

                      </div>

                    </Link>


                    {/* DECTWIN LOGO */}
                    <img
                      src={logo}
                      alt="Dectwin"
                      style={{
                        width: isMobile ? "42px" : "50px",
                        height: isMobile ? "42px" : "50px",
                        objectFit: "contain",
                      }}
                    />

                  </div>

                </div>

              </div>

            )}


            {/* =================================================
                BILLING ROUTES
            ================================================= */}

            <Routes>

              <Route
                path="/"
                element={<Home />}
              />

              <Route
                path="/home"
                element={
                  <Home
                    clientData={clientData}
                  />
                }
              />


              {/* OVERVIEW */}
              <Route
                path="/overview"
                element={
                  <Overview
                    clientData={clientData}
                  />
                }
              />


              {/* PARTY */}
              <Route
                path="/party"
                element={
                  <Party
                    clientData={clientData}
                    appTheme={appTheme}
                  />
                }
              />


              {/* ITEMS */}
              <Route
                path="/items"
                element={
                  <Items
                    clientData={clientData}
                  />
                }
              />


              {/* MANAGE BUSINESS */}
              <Route
                path="/managebussines"
                element={
                  <ManageBussines
                    clientData={clientData}
                    setClientData={setClientData}
                  />
                }
              />


              {/* BANK ACCOUNT */}
              <Route
                path="/bankaccount"
                element={
                  <Bank_account
                    clientData={clientData}
                  />
                }
              />


              {/* CASH */}
              <Route
                path="/cashinhand"
                element={
                  <Cash
                    clientData={clientData}
                  />
                }
              />


              {/* ADD STAFF */}
              <Route
                path="/addstaff"
                element={
                  <Addstaff
                    clientData={clientData}
                  />
                }
              />


              {/* EXPENSE */}
              <Route
                path="/expenses"
                element={
                  <Expenses
                    clientData={clientData}
                    role={role}
                  />
                }
              />

              <Route
                path="/expenseshistory"
                element={
                  <Expenseshistory
                    clientData={clientData}
                    role={role}
                  />
                }
              />


              {/* BARCODE */}
              <Route
                path="/generatebarcode"
                element={
                  <GenerateBarcode
                    clientData={clientData}
                  />
                }
              />


              {/* PURCHASE */}
              <Route
                path="/purchase"
                element={
                  <Purchase
                    clientData={clientData}
                  />
                }
              />

              <Route
                path="/Addpurchase"
                element={
                  <Addpurchase
                    clientData={clientData}
                    role={role}
                  />
                }
              />

              <Route
                path="/purchaseReturn"
                element={
                  <PurchaseReturn
                    clientData={clientData}
                    role={role}
                  />
                }
              />

              <Route
                path="/purchase-return-history"
                element={
                  <PurReturnHistory
                    clientData={clientData}
                    role={role}
                  />
                }
              />


              {/* ESTIMATE */}
              <Route
                path="/add-estimate"
                element={
                  <AddEstimate
                    clientData={clientData}
                    role={role}
                  />
                }
              />

              <Route
                path="/estimate-history"
                element={
                  <EsitmateHistory
                    clientData={clientData}
                    role={role}
                  />
                }
              />

              <Route
                path="/estimate-to-sale"
                element={
                  <ConvertToSsle
                    clientData={clientData}
                    role={role}
                  />
                }
              />


              {/* SALE */}
              <Route
                path="/add-sale"
                element={
                  <AddSale
                    clientData={clientData}
                    role={role}
                  />
                }
              />

              <Route
                path="/sale-history"
                element={
                  <SaleHistory
                    clientData={clientData}
                    role={role}
                  />
                }
              />

              <Route
                path="/sale-return"
                element={
                  <SaleReturn
                    clientData={clientData}
                    role={role}
                  />
                }
              />

              <Route
                path="/sale-return-history"
                element={
                  <SaleReturnHistory
                    clientData={clientData}
                    role={role}
                  />
                }
              />

              <Route
                path="/payment-in-history"
                element={
                  <PaymentInHistory
                    clientData={clientData}
                    role={role}
                  />
                }
              />


              {/* CHALLAN */}
              <Route
                path="/challan-invoice"
                element={
                  <Challan_Invoice
                    clientData={clientData}
                    role={role}
                  />
                }
              />

              <Route
                path="/challan-list"
                element={
                  <Challan_List
                    clientData={clientData}
                    role={role}
                  />
                }
              />


              {/* OTHER */}
              <Route
                path="/loyalitypoints"
                element={<LoyalityPoints />}
              />

              <Route
                path="/notificaton"
                element={<Notification />}
              />

              <Route
                path="/setting"
                element={<Setting />}
              />

              <Route
                path="/themetoggle"
                element={<ThemeToggle />}
              />

              <Route
                path="/reports"
                element={<Reports />}
              />

              <Route
                path="/premium"
                element={<Premium />}
              />

              <Route
                path="/salewisereport"
                element={<Saleswisereport />}
              />

              <Route
                path="/settlementreport"
                element={<SettlementReport />}
              />

              <Route
                path="/taxreport"
                element={<TaxReport />}
              />

              <Route
                path="/stokereport"
                element={<Stoke />}
              />

              <Route
                path="/profitLossreport"
                element={<ProfitLossReport />}
              />

              <Route
                path="/purchasereport"
                element={<ProfitLossReport />}
              />

              <Route
                path="/cheque"
                element={<Cheque />}
              />

              <Route
                path="/services"
                element={
                  <Services
                    clientData={clientData}
                  />
                }
              />

              <Route
                path="/category"
                element={
                  <Category
                    clientData={clientData}
                  />
                }
              />

              <Route
                path="/units"
                element={
                  <Units
                    clientData={clientData}
                  />
                }
              />

              <Route
                path="/branch"
                element={<Branch />}
              />


              {/* IMAGE / INVOICE PREVIEW */}
              <Route
                path="/invoice-preview"
                element={
                  <InvoicePreview
                    clientData={clientData}
                  />
                }
              />


              {/* 404 */}
              <Route
                path="*"
                element={<Pnf />}
              />

            </Routes>

<MobileBottomNav
  clientData={clientData}
  lowStockCount={lowStockCount}
/>
            </div>

          </div>

        </>

      )}


      {/* =====================================================
          TOAST
      ===================================================== */}

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />

    </BrowserRouter>
  );
}

export default App;

